import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.authenticated().then(isAuthenticated => {
      if (isAuthenticated)
        return true;

      // not logged in so redirect to login page with the return url and return false
      this.router.navigate(['/account/signin'], { queryParams: { returnUrl: state.url } });
      return false;
    });
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/auth/auth-guard.ts